/*
 * Generated by scripts/assets/asset-versions.mjs — do not edit.
 * `npm run assets:versions` rewrites it; `npm run assets:versions:check` fails CI when a
 * file under frontend/public/games or frontend/public/shared changed without it.
 */
export const ASSET_VERSIONS: Readonly<Record<string, string>> = {
  'games/bridge-patterns': '583f030ca67d',
  'games/kalqy-world': 'e5e16762cdc7',
  'games/letter-lagoon': 'eeac22162173',
  'games/sky-quest': 'f058e792cec0',
  'games/turos-world': '9840f2141e2b',
  'shared': '524b71b9cc20',
}
